import PropTypes from 'prop-types';

import { Input } from 'dibs-elements/exports/Input';

function Text(props) {
    const {
        autoComplete = 'on',
        autoFocus = false,
        dataTn = '',
        error,
        isBlurred = false,
        disabled = false,
        maxLength,
        name,
        onBlur = () => {},
        onChange = () => {},
        onChangeEvent = () => {},
        onFocus = () => {},
        pattern,
        placeholder = '',
        type = 'text',
        value,
        wrapperClass = '',
        leftDecorator,
        rightDecorator,
        inputMode,
    } = props;

    const showError = !disabled && isBlurred && !!error;
    const hasValidText = isBlurred && !!value && !showError;

    return (
        <div className={wrapperClass} data-field={name}>
            <Input
                onChange={event => {
                    // need access to raw event for credit card num auto-format
                    onChangeEvent(event);
                    onChange({ name, value: event.target.value });
                }}
                onBlur={event => onBlur({ name, value: event.target.value })}
                onFocus={onFocus}
                type={type}
                dataTn={dataTn}
                name={name}
                value={value}
                pattern={pattern}
                maxLength={maxLength}
                placeholder={placeholder}
                errorMessage={showError && error}
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                disabled={disabled}
                hasValidText={hasValidText}
                hasAnimatedPlaceholder
                size="large"
                maskForPrivacy
                leftDecorator={leftDecorator}
                rightDecorator={rightDecorator}
                inputMode={inputMode}
            />
        </div>
    );
}

Text.propTypes = {
    autoComplete: PropTypes.string,
    autoFocus: PropTypes.bool,
    dataTn: PropTypes.string.isRequired,
    error: PropTypes.string,
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    maxLength: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onChangeEvent: PropTypes.func,
    onFocus: PropTypes.func,
    pattern: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string.isRequired,
    wrapperClass: PropTypes.string,
    leftDecorator: PropTypes.node,
    rightDecorator: PropTypes.node,
    inputMode: PropTypes.string,
};

export default Text;
